import React from "react";
import { Route, Switch } from "react-router-dom";

import { Layout } from "../components/Advisor/Layout";
import Advisor from "../containers/Advisor/Advisor";
import Weather from "../containers/Advisor/Weather";
import Wishlist from "../containers/Advisor/Wishlist";
import Settings from "../containers/Advisor/Settings";

class AdvisorRouter extends React.Component {
  render() {
    return (
      <Layout database={this.props.database}>
        <Switch>
          <Route exact path="/weather" component={Weather} />
          <Route exact path="/wishlist" component={Wishlist} />
          <Route exact path="/settings" component={Settings} />
          <Route path="/" component={Advisor} />
        </Switch>
      </Layout>
    );
  }
}

export default AdvisorRouter;
